import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react'
import Select from 'react-select';
import ColumnsDevider from '../../../customControl/ColumnsDevider';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../_actions/loader.actions';
import { getAllData, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../components/commonClass/Session';
import { CorporateAgentAssignmentRef, kamManager, regionAssignment, salesManager } from '../../TravelAgentManagement/partial/TravelAgent.interface';

interface corporateDropdownList {
  regionList: regionAssignment[]
}

const CorporateAssignment = forwardRef<CorporateAgentAssignmentRef, any>((props: any, ref) => {
  const { tabId, selectedTabId, isSaved, setIsSaved, isConfirm, setIsConfirm, setIsRedirect, CorporateId, warningMessages, setWarningMessages, domainWiseDisable } = props
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [dropdownList, setDropDownList] = useState<corporateDropdownList>()
  const [formError, setFormError] = useState<any>(null);
  const [editcleardisabled, setEditClearDisabled] = useState(true)
  const [formValue, setFormValue] = useState({
    CorporateAssignmentId: 0,
    CorporateId: 0,
    SalesManagerUserId: 0,
    KAMManagerUserId: 0,
    RegionId: 0,
    UserId: 0,
  })

  const getdropdowndata = async () => {
    dispatch(loaderActions.start());
    let statusoftoken = await verifytoken();
    if (statusoftoken) {
      const list = await getAllData('/midoffice/v1/getassignmentoption')
      if (list?.status) {
        list?.data?.regionList?.map((obj: regionAssignment) => {
          obj.label = obj?.regionName
          obj.value = obj?.regionId
          obj.kamUsers = obj?.kamUsers?.map((ele: kamManager) => {
            ele.label = ele?.userName
            ele.value = ele?.userMasterID
            return ele;
          })
          obj.salesManagerUsers = obj?.salesManagerUsers?.map((ele: salesManager) => {
            ele.label = ele?.userName
            ele.value = ele?.userMasterID
            return ele;
          })
          return obj;
        })
        setDropDownList(list?.data);
      }
    }
    else {
      ClearLocalStorage();
      dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
      dispatch(loaderActions.end());
    }
    dispatch(loaderActions.end());
  }

  const onChange = (name: any, val: any) => {
    setWarningMessages([]);
    setFormError(null);
    setIsSaved((save: any) => ({ ...save, Assignment: false }))
    setEditClearDisabled(false);
    if (name === "RegionId") {
      setFormValue((form: any) => ({ ...form, RegionId: val ? val : 0, SalesManagerUserId: 0, KAMManagerUserId: 0 }))
    }
    else {
      setFormValue((form: any) => ({ ...form, [name]: val ? val : 0 }))
    }
  }

  const validation = () => {
    setWarningMessages([]);
    let status: boolean = true;
    const error: any = {}

    if (formValue?.RegionId === 0) {
      error.RegionId = "Please select region.";
      status = false;
    }
    // if (formValue?.SalesManagerUserId === 0 && formValue?.KAMManagerUserId === 0) {
    //   error.SalesManagerUserId = "Please appoint at least Sales Manager or KAM.";
    //   status = false;
    // }

    setFormError(error);

    if (Object.keys(error)?.length > 0) {
      const id = Object.keys(error)?.[0];
      document.getElementById(id)?.focus();
    }

    return status;
  }

  //#region Warning Message function
  useImperativeHandle(ref, () => ({
    warningValidation() {
      if (formValue?.SalesManagerUserId === 0 && formValue?.KAMManagerUserId === 0) {
        return {
          tabId: tabId,
          errorMessages: { selectManagerValidation: "Please appoint at least Sales Manager or KAM." }
        }
      }
      else if (!isSaved?.Assignment) {
        return {
          tabId: tabId,
          errorMessages: { selectManagerValidation: "There are unsaved data, please save first." }
        }
      }
      else {
        return null;
      }
    }
  }))
  //#endregion

  //#region get warning messages
  const selectManagerValidation = useMemo(() =>
    warningMessages?.find((fin: any) => fin?.tabId === tabId)?.errorMessages?.selectManagerValidation || null
    , [warningMessages])
  //#endregion

  const saveDate = async () => {
    setIsConfirm(isConfirm === 1 && selectedTabId === tabId ? 2 : 0);
    if (validation()) {
      dispatch(loaderActions.start());
      let statusoftoken = await verifytoken();
      if (statusoftoken) {
        let user: any = GetLocalStorage();
        formValue.UserId = user?.userMasterID
        const RpsData = await postUsersData("/midoffice/v1/insertorupdatecorporateassignment", formValue);
        if (RpsData?.status) {
          setIsSaved((save: any) => ({ ...save, Assignment: true }))
          setIsRedirect(true);
          dispatch({ type: 'ALERTING', message: RpsData?.message })
        }
        else {
          dispatch({ type: 'ALERTING', message: RpsData?.message })
        }
        dispatch(loaderActions.end());
      }
      else {
        ClearLocalStorage();
        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        dispatch(loaderActions.end());
      }

    }
  }

  const getbyid = async (id: any) => {
    dispatch(loaderActions.start());
    let statusoftoken = await verifytoken();
    if (statusoftoken) {
      const list = await getAllData(`/midoffice/v1/getcorporateassignmentbyid?corporateid=${id}`)
      if (list?.status && list?.data) {
        setFormValue({
          CorporateAssignmentId: list?.data?.[0]?.CorporateAssignmentId ? list?.data?.[0]?.CorporateAssignmentId : 0,
          CorporateId: id,
          SalesManagerUserId: list?.data?.[0]?.SalesManagerUserId ? list?.data?.[0]?.SalesManagerUserId : 0,
          KAMManagerUserId: list?.data?.[0]?.KAMManagerUserId ? list?.data?.[0]?.KAMManagerUserId : 0,
          RegionId: list?.data?.[0]?.RegionId ? list?.data?.[0]?.RegionId : [],
          UserId: 0,
        })
      }
      dispatch(loaderActions.end());
    }
    else {
      ClearLocalStorage();
      dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
      dispatch(loaderActions.end());
    }
  }

  const clearData = () => {
    setWarningMessages([]);
    setFormError(null);
    setIsSaved((save: any) => ({ ...save, Assignment: false }))
    setFormValue((form: any) => ({
      ...form,
      SalesManagerUserId: 0,
      KAMManagerUserId: 0,
      RegionId: 0,
    }))
  }

  useEffect(() => {
    if (CorporateId) {
      setFormValue((form) => ({ ...form, CorporateId: CorporateId }));
      getbyid(CorporateId)
    }
  }, [CorporateId])

  useEffect(() => {
    getdropdowndata();
  }, [])

  useEffect(() => {
    if (isConfirm === 1 && selectedTabId === tabId) {
      saveDate()
    }
  }, [isConfirm])


  const selectedRegion = useMemo(() => {
    return dropdownList?.regionList?.find((ele: regionAssignment) => ele?.regionId === formValue?.RegionId)
  }, [dropdownList?.regionList, formValue?.RegionId])

  return (
    <div className='mt-5'>
      {
        selectManagerValidation ?
          selectManagerValidation && <div className="text-danger text-center mb-2 fs_14"> {selectManagerValidation} </div>
          :
          formError?.SalesManagerUserId && <div className="text-danger text-center mb-2 fs_14"> {formError?.SalesManagerUserId} </div>
      }
      <div className='row'>
        <ColumnsDevider label='Region/zone' isRequired>
          <Select
            inputId='RegionId'
            className="dropdown select_dropdown custom_class"
            options={dropdownList?.regionList}
            value={dropdownList?.regionList?.filter((regionData: regionAssignment) => {
              return regionData?.value === formValue?.RegionId;
            })}
            onChange={(e: any) => onChange('RegionId', e?.value)}
            isDisabled
            isSearchable={true}
            isClearable
          />
          {formError?.RegionId && <div className="text-danger fs_14"> {formError?.RegionId} </div>}
        </ColumnsDevider>
      </div>

      <div className='row'>
        <ColumnsDevider label='Assigned Sales Manager'>
          <Select
            inputId='SalesManagerUserId'
            className="dropdown select_dropdown custom_class"
            options={selectedRegion?.salesManagerUsers}
            value={selectedRegion?.salesManagerUsers?.filter((fil) => fil?.value === formValue?.SalesManagerUserId) || null}
            onChange={(e: any) => onChange('SalesManagerUserId', e?.value)}
            isDisabled={location?.state?.disabled || domainWiseDisable?.assignmentField || domainWiseDisable?.isExternalUser}
            isSearchable={true}
            isClearable
          />
        </ColumnsDevider>

        <ColumnsDevider label='Assigned KAM'>
          <Select
            inputId='KAMManagerUserId'
            className="dropdown select_dropdown custom_class"
            options={selectedRegion?.kamUsers}
            value={selectedRegion?.kamUsers?.filter((fil) => fil?.value === formValue?.KAMManagerUserId) || null}
            onChange={(e: any) => onChange('KAMManagerUserId', e?.value)}
            isDisabled={location?.state?.disabled || domainWiseDisable?.assignmentField || domainWiseDisable?.isExternalUser}
            isSearchable={true}
            isClearable
          />
        </ColumnsDevider>
      </div>

      <div className="mt-3 d-flex justify-content-center mt-5">
        <button type="button" className="btn btn-primary mx-1 px-3" disabled={location?.state?.disabled || editcleardisabled || domainWiseDisable?.isExternalUser} onClick={() => saveDate()} id="btnAdd">{domainWiseDisable?.loginUserDomainMasterId !== 1 ? "Save AS Draft" : (location?.state?.viewtype === 'Update' ? 'Update' : 'Save')}</button>
        <button type="button" className="btn btn-primary mx-1 px-3" disabled={editcleardisabled || location?.state?.disabled || domainWiseDisable?.isExternalUser} onClick={() => clearData()} id="btnAdd">Clear</button>
        <button type="button" className="btn btn-primary mx-1 px-3" onClick={() => navigate('/corporate-management')} id="btnClear">Back</button>
      </div>
    </div>
  )
}
)

export default CorporateAssignment